import { type TypePolicies } from "@apollo/client"

export const objectMapping: TypePolicies = {
  ObjectMappingHierarchyNode: {
    keyFields: ["factId"],
  },
}
